module.exports = __webpack_public_path__ + "images/1click_9db949441f5c8f22b95a9a5e44cabeb8.png";